import React from 'react';
import { useWizardProgress } from '../../hooks/useLevelUpWizard';
import { WizardStep } from '../../stores/levelUpStore';
import styles from './WizardProgress.module.css';

/**
 * Progress indicator showing current step and completion status
 */
export const WizardProgress: React.FC = () => {
  const {
    currentStep,
    stepName,
    currentStepNumber,
    totalSteps,
    stepsComplete
  } = useWizardProgress();

  const steps = [
    { name: 'Welcome', key: WizardStep.WELCOME },
    { name: 'Tier Achievement', key: WizardStep.TIER_ACHIEVEMENT },
    { name: 'Advancements', key: WizardStep.ADVANCEMENTS },
    { name: 'Domain Cards', key: WizardStep.DOMAIN_CARDS },
    { name: 'Summary', key: WizardStep.SUMMARY },
    { name: 'Complete', key: WizardStep.COMPLETION }
  ];

  return (
    <div className={styles.wizardProgress}>
      <div className={styles.stepIndicator}>
        <span className={styles.stepLabel}>
          Step {currentStepNumber} of {totalSteps}
        </span>
        <span className={styles.stepName}>{stepName}</span>
      </div>

      <div className={styles.progressBar}>
        {steps.map((step, index) => (
          <div
            key={step.key}
            className={`${styles.progressDot} ${
              currentStep === step.key ? styles.active : ''
            } ${currentStep > step.key ? styles.complete : ''}`}
            title={step.name}
          />
        ))}
      </div>
    </div>
  );
};
